import { Cacheable } from './cacheable.model';

export interface Form extends Cacheable {
    id: string;
    background?: FormsBackground;
    category?: any;
    dateTimeShared?: string;
    sharedBy: string;
    status?: string;
    modifiedDate?: Date;
    otherInfo?: FormOtherInfo;
    ownerId: string;
    ownerDisplayName?: string;
    settings?: string;
    title: string;
    defaultAppRestriction?: string;
    ownerTenantId: string;
    // Forms bug where OwnerTenantId is capitalized in the sharedwithme forms call. We will default to ownerTenentId lowercase over this one and set that with the capitalized field.
    OwnerTenantId: string;
    ownerPrincipalType?: FormType;
    // Forms bug where OwnerPrincipalType is capitalized in the sharedwithme forms call. We will default to ownerTenentId lowercase over this one and set that with the capitalized field.
    OwnerPrincipalType?: string;
    // Forms is deprecating the ownerPrincipalType for the ownerType field name.
    ownerType?: string;
    softDeleted?: number;
    // Url not returned by forms API, constructed on client side
    url?: string;
    version?: string;
    // Number of responses the form has
    rowCount?: number;
    trackingId: string;
    // Indicates if the form is a survey or a poll
    type: string;
}

export const enum FormEnum {
    Survey = 'survey',
    Form = 'form',
    Poll = 'poll',
    Assignments = 'assignments'
}

export const enum FormSubtypeCategory {
    Poll = 'poll',
    TeamsPoll = 'teams poll',
    PPTPoll = 'pptpoll',
    WordPoll = 'wordpoll',
    Assignments = 'assignments'
}

export enum FormType {
    Users = 'users',
    Groups = 'groups'
}

export enum UserReputationTier {
    Good,
    Normal,
    Suspicious,
    Bad,
    Evil
}

export interface FormsGroupMember {
    id: string;
    displayName: string;
    givenName: string;
    jobTitle: string;
    mail: string;
    surname: string;
    userPrincipalName: string;
}

export interface FormOtherInfo {
    Theme?: FormTheme;
    PrimaryCustomizedThemeColor?: string;
    // Secondary is color used for transparent thumbnail background
    SecondaryCustomizedThemeColor?: string;
    TertiaryCustomizedThemeColor?: string;
}

export interface FormTheme {
    // Field is used to construct this link to fetch background for each form: https://forms.office.com/Images/Theme/${Name}.png
    Name?: string;
}

export interface GetFormsResponse<T> extends Cacheable {
    // Properties from Cacheable is not apart of original server response.
    value: Array<T>;
}

export interface GetFormResponse<T> extends Cacheable {
    value: T;
}

export interface GetResponseCountsResponse extends Cacheable {
    // Todo: Confirm if Forms API returns single object on single object return and not a single object encased in an array.
    value: Array<FormsResponseCount> | FormsResponseCount;
}

export interface FormsResponseCount {
    id: string;
    responseCount: number;
}

export interface FormsBackground {
    altText?: any;
    contentType: string;
    fileIdentifier: string;
    originalFileName: string;
    resourceId: string;
    resourceUrl: string;
    height?: any;
    width?: any;
    size?: any;
}

export interface FormsThemeMappingObject {
    BackgroundColor: string;
    BackgroundImage: string;
    Name: string;
    PrimaryColor: string;
    SecondaryColor: string;
}

export interface FormsThemeMappingSet {
    [key: string]: FormsThemeMappingObject;
}

export interface FormsGroup {
    id: string;
    accessType?: any;
    displayName: string;
    emailAddress: string;
    isFavorite: boolean;
    classification: string;
    visibility: string;
    members: Array<any>;
    owners: Array<any>;
}

export class FormsHelperFunctions {
    public static getOwnerPrincipalTypeToFormType(ownerPrincipalType: string) {
        if (ownerPrincipalType.toLowerCase() === 'user') {
            return FormType.Users;
        } else if (ownerPrincipalType.toLowerCase() === 'group') {
            return FormType.Groups;
        }
    }

    public static getExtensionToFormType(extension: string) {
        if (extension.toLowerCase() === 'form') {
            return FormType.Users;
        } else if (extension.toLowerCase() === 'groupform') {
            return FormType.Groups;
        }
    }
}
